import type { RouteObject } from 'react-router-dom';
import { createElement } from 'react';
import { AppShell } from '@/shared/ui/layout/AppShell';
import { ProtectedRoute } from '@/app/router/ProtectedRoute';
import ParcelsPage from '@/pages/parcels';
import ParcelCreatePage from '@/pages/parcel-create';
import ParcelDetailPage from '@/pages/parcel-detail';
import ParcelDeclarationPage from '@/pages/parcel-declaration';
import ParcelClaimPage from '@/pages/parcel-claim';
import SplitDetailPage from '@/pages/split-detail';
import PackagesPage from '@/pages/packages';
import PackageDetailPage from '@/pages/package-detail';
import IdsPage from '@/pages/ids';
import IdsRequestPage from '@/pages/ids-request';
import IdsConnectPage from '@/pages/ids-connect';
import SettingsPage from '@/pages/settings';
import ProfilePage from '@/pages/profile';
import PaymentsPage from '@/pages/payments';
import AddressesPage from '@/pages/addresses';
import AddressCreatePage from '@/pages/address-create';
import AddressEditPage from '@/pages/address-edit';
import OnlineAddressPage from '@/pages/online-address';
import SupportPage from '@/pages/support';
import SupportChatPage from '@/pages/support/chat';
import SupportStaffPage from '@/pages/support-staff';
import ServicesPhotoPage from '@/pages/services-photo';
import ServicesPhotoFormPage from '@/pages/services-photo-form';
import ServicesVideoPage from '@/pages/services-video';
import ServicesVideoFormPage from '@/pages/services-video-form';
import ServicesProverkaPage from '@/pages/services-proverka';
import ServicesProverkaFormPage from '@/pages/services-proverka-form';
import ServicesReturnPage from '@/pages/services-return';
import ServicesReturnFormPage from '@/pages/services-return-form';
import ServicesSplitPage from '@/pages/services-split';
import ServicesListPage from '@/pages/services-list';
import NotificationsPage from '@/pages/notifications';
import { FeaturesNotificationsBell } from '@/features/notifications';

const wrap = (node: React.ReactNode): React.ReactElement =>
  createElement(
    ProtectedRoute,
    null,
    createElement(AppShell, {
      headerActions: createElement(FeaturesNotificationsBell),
      children: node,
    }),
  );

export const protectedRoutes: RouteObject[] = [
  { path: '/', element: wrap(ParcelsPage), index: false },
  { path: '/parcels', element: wrap(ParcelsPage) },
  { path: '/parcels/create', element: wrap(ParcelCreatePage) },
  { path: '/parcels/claim', element: wrap(ParcelClaimPage) },
  { path: '/parcels/:id', element: wrap(ParcelDetailPage) },
  { path: '/parcels/:id/declaration', element: wrap(ParcelDeclarationPage) },
  { path: '/splits/:id', element: wrap(SplitDetailPage) },
  { path: '/packages', element: wrap(PackagesPage) },
  { path: '/packages/:id', element: wrap(PackageDetailPage) },
  { path: '/ids', element: wrap(IdsPage) },
  { path: '/ids/request', element: wrap(IdsRequestPage) },
  { path: '/ids/connect', element: wrap(IdsConnectPage) },
  { path: '/settings', element: wrap(SettingsPage) },
  { path: '/settings/profile', element: wrap(ProfilePage) },
  { path: '/settings/payments', element: wrap(PaymentsPage) },
  { path: '/settings/addresses', element: wrap(AddressesPage) },
  { path: '/settings/addresses/new', element: wrap(AddressCreatePage) },
  { path: '/settings/addresses/:id/edit', element: wrap(AddressEditPage) },
  { path: '/settings/online-address', element: wrap(OnlineAddressPage) },
  { path: '/settings/services', element: wrap(ServicesListPage) },
  { path: '/support', element: wrap(SupportPage) },
  { path: '/support/chat', element: wrap(SupportChatPage) },
  { path: '/support-staff', element: wrap(SupportStaffPage) },
  { path: '/services/photo', element: wrap(ServicesPhotoPage) },
  { path: '/services/photo/:parcelId', element: wrap(ServicesPhotoFormPage) },
  { path: '/services/video', element: wrap(ServicesVideoPage) },
  { path: '/services/video/:parcelId', element: wrap(ServicesVideoFormPage) },
  { path: '/services/proverka', element: wrap(ServicesProverkaPage) },
  { path: '/services/proverka/:parcelId', element: wrap(ServicesProverkaFormPage) },
  { path: '/services/return', element: wrap(ServicesReturnPage) },
  { path: '/services/return/:parcelId', element: wrap(ServicesReturnFormPage) },
  { path: '/services/split', element: wrap(ServicesSplitPage) },
  { path: '/notifications', element: wrap(NotificationsPage) },
];
